module.exports = __webpack_public_path__ + "img/favicon_32x32.bc50427b.png";